import * as React from 'react';

import {Body} from '../typography/body';
import {useRefObserver} from '../utils/hooks/use-ref-observer';

import styles from './breadcrumb-value.module.css';

type Props = {
    title: string;
    subtitle?: string | React.ReactNode;
    state: 'initial' | 'selected' | 'past';
    isDisabled?: boolean;
    preventUnderline?: boolean;
    titleSize?: 'small' | 'normal';
    subtitleSize?: 'mini' | 'small' | 'normal';
    subtitleColor?: 'light' | 'medium';
};

export function BreadcrumbValue(props: Props) {
    const {titleSize = 'small', subtitleSize = 'small', subtitleColor = 'medium'} = props;
    const ref = React.useRef(null);

    const {isHovered} = useRefObserver(ref, ['isHovered']);

    return (
        <div className='flex flex-dir-col text-align-left' ref={ref}>
            <Body
                size={titleSize}
                isBold={props.state === 'selected'}
                underline={Boolean(!props.preventUnderline && !props.isDisabled && isHovered)}
            >
                {props.title}
            </Body>
            {props.subtitle && (
                <div className={subtitleSize === 'mini' ? '' : styles.subtitle}>
                    <Body size={subtitleSize} color={subtitleColor} isItalic={true}>
                        {props.subtitle}
                    </Body>
                </div>
            )}
        </div>
    );
}
